<template>
  <div class="cal-out" v-if="!isLoading">
    <div class="cal-div flex flex-col" v-if="isBegin">
      <!-- 进度条 -->
      <van-progress-jhd
        :percentage="percent"
        track-color="#FEEEC0"
        color="linear-gradient(90deg, #FF770F 0%, #E41919 100%)"
        stroke-width="6"
      >
        <img
          src="@/assets/signIn/gift.png"
          class="gift-class"
          style="width: 100%"
          alt=""
        />
      </van-progress-jhd>
      <!-- <div class="flex flex-row-end color-white m-t-6">
        <span>10/100</span>
      </div> -->
      <!-- button -->
      <div class="flex flex-row-center btn-div">
        <van-button
          @click="handleSignin"
          class="btn"
          :class="{ 'btn-dis': isComplete || percent >= 100 || isSigninToday }"
          type="warning"
          round
          color=""
        >
          <div class="flex flex-col-center">
            <img
              src="@/assets/signIn/complete.png"
              class="complete-class"
              style="width: 100%"
              alt=""
              v-if="isSigninToday || isComplete || percent >= 100"
            />
            <span v-if="isComplete || percent >= 100">任务完成</span>
            <span v-else-if="isSigninToday">签到完成</span>
            <span v-else>立即签到</span>
          </div>
        </van-button>
      </div>
      <!-- 规则 -->
      <div
        class="
          flex flex-row-center flex-col flex-col-center
          font-10
          color-white
          text-div
        "
      >
        <span>{{ rule }}</span>
      </div>
      <div class="flex flex-between flex-col-bottom">
        <img src="@/assets/signIn/flower.png" fit="contain" class="flower" />
        <img src="@/assets/signIn/tree.png" fit="contain" class="tree" />
      </div>
      <img src="@/assets/signIn/line.png" fit="contain" class="line-img" />
      <div class="cal">
        <van-calendar
          :show-confirm="false"
          v-model="show"
          :poppable="false"
          type="multiple"
          :min-date="minDate"
          :max-date="maxDate"
          :defaultDate="defaultDate"
          :show-subtitle="false"
          readonly
        >
          <div slot="title">
            <div class="sub-title"></div>
            <div class="custom-title">
              <van-icon
                name="arrow-left"
                @click="handleChange('left')"
              ></van-icon>
              <span style="padding: 0 20px">{{ defaultMonth }}</span>
              <van-icon name="arrow" @click="handleChange('right')"></van-icon>
            </div>
          </div>
        </van-calendar>
      </div>
    </div>
    <div v-else class="flex flex-row-center flex-col-center m-t-153">
      <no-data :img-src="require('@/assets/signIn/empty.png')" :img-size="''" desc="下一波签到活动正在路上，请耐心等待哦…" showType="coupon" imgWidth="222px" imgHeight="116px"></no-data>
    </div>
    <van-popup v-model="showPop">
      <div class="tip-div">
        <div class="title1">签到奖励</div>
        <div class="title2">+{{ dayPrize }}积分</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import NoData from '@/components/noData'
export default {
  components:{NoData},
  data() {
    return {
      show: true,
      defaultMonth:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1),
      minDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      maxDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      defaultDate: [],
      platformType: 1,
      isSigninToday: false,
      isComplete: false,
      signInCount: 0,
      signInSum: 0,
      rule: "",
      dayPrize: 0,
      isBegin: false,
      isLoading: false,
      showPop: false,
      signinType:2,// 当前支持手动/自动签到 1-只支持手动签到，2-支持手动+自动
    };
  },
  computed: {
    percent() {
      if (this.signInSum <= 0) return 0;
      return parseInt((this.signInCount / this.signInSum) * 100);
    },
  },
  async mounted() {
    // console.log(this.minDate);
    // console.log(this.maxDate);
    this.isLoading = true
    await this.taskDetail();
    if(this.isBegin) await this.taskProgress();
    if(!this.isSigninToday && this.signinType == 2 && this.isBegin) this.signInFn();
    // this.show = true
  },
  methods: {
    handleSignin: function () {
      this.signInFn(1);
    },
    /**
     * @description 签到操作
     * @param {String|Number} type  1手动签到   2自动签到 default 2
     */
    signInFn: function (type = 2) {
      if (this.isSigninToday) {
        // this.$toast('您今天已经签到，无需再签')
        return;
      }
      return new Promise((resolve, reject) => {
        const param = {
          platformType: this.platformType, //平台：0-B2B，1-B2C，2-HSY
          type: type,
        };
        this.$service
          .getSignIn(param)
          .then((res) => {
            // console.log(res)
            if (res.result.signinState > 0) {
              const now = this.$moment(new Date()).format("YYYY-MM-DD");
              const selected = this.defaultDate;
              selected.push(new Date(now));
              this.defaultDate = selected;
              // 签到天数手动增加一天
              this.signInCount = parseInt(res.result.dayCount);
              // const today =
              if (this.percent >= 100 || res.result.flag > 0) {
                this.isComplete = true;
                // this.showSuccess = true
              }
              this.showPop = true;
              this.dayPrize = res.result.dayPrize;
              this.isSigninToday = true;
            } else {
              this.showPop = false;
              this.isSignToday = false;
              // 签到失败
              this.$toast("签到失败，请重试");
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * @description 任务详情
     */
    taskDetail: function () {
      return new Promise(resolve=>{
        const param = {
          platformType: this.platformType,
          state: 1, //状态: 1进行中 2未开始 3已结束
        };
        this.$service.task(param).then((res) => {
          // console.log(res);
          this.isLoading = false
          if (res.result <= 0) {
            this.isBegin = false;
          } else {
            this.isBegin = true;
          }
          resolve(res)
        });
      })
    },
    /**
     * @description 任务进度
     */
    taskProgress: function () {
      return new Promise((resolve) => {
        const param = {
          platformType: this.platformType,
          month: this.$moment(this.minDate).format("YYYY-MM"),
        };
        console.log(param);
        this.$service.detail(param).then((res) => {
          /**
           * specification - 规则
           * signinListRespone - 签到列表
           * signinState - 是否已签到（今天）
           * flag - 是否 任务完成 0-1
           * dayCount - 已签到天数（以任务为准）
           * sumFrequency - 总任务天数
           */
          console.log(res);
          this.rule = res.result.specification;
          this.signInCount = res.result.dayCount;
          this.signInSum = res.result.sumFrequency;
          this.signinType = res.result.signinType
          if (res.result.flag == 1) this.isComplete = true;
          const today = this.$moment(new Date()).format("YYYY-MM-DD");
          if (res.result.signinListRespone) {
            const list = res.result.signinListRespone;
            this.defaultDate = list.map((item) => {
              return new Date(item.createDay);
            });
          }
          if (
            (this.defaultDate.length &&
              this.$moment(
                this.defaultDate[this.defaultDate.length - 1]
              ).format("YYYY-MM-DD") == today) ||
            res.result.signinState > 0
          ) {
            this.isSigninToday = true;
          }
          resolve(res)
        });
      });
    },
    handleChange: function (t) {
      let ac = this.minDate.getMonth();
      // 暂时限定至当年
      let year = new Date().getFullYear();
      if (t == "left") {
        ac -= 1;
      }
      if (t == "right") {
        ac += 1;
      }
      let de_ac = ac + 1;
      if (de_ac == 0) de_ac = 12;
      if (de_ac == 13) de_ac = 1;
      // console.log(ac);
      this.minDate = new Date(year, ac, 1);
      this.maxDate = new Date(year, ac + 1, 0);
      this.defaultMonth = year + "-" + (de_ac < 10 ? "0" + de_ac : de_ac);
    },
  },
};
</script>
<style lang="less">
.cal-div {
  min-height: 100vh;
  padding: 10px;
  background: url("../../assets/signIn/big-bg.png") #FEBB5C no-repeat;
  background-size: 100% 100vh;
  padding-top: 52px;
  .van-calendar__body .van-calendar__day,van-calendar__header .van-calendar__weekday{
    font-size: 12px;
  }
}
.custom-title {
  background: #ffdfc3;
  color: #ff770f;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 47px;
  margin-top: -8px;
}
.cal {
  padding: 0 10px;
  margin-top: -8px;
}
.line-img {
  width: 100%;
  height: 16px;
}
.flower {
  height: 46px;
  margin-bottom: -16px;
  margin-left: 12px;
}
.tree {
  height: 76px;
}
.btn-div {
  margin-top: 29px;
  .btn {
    // width: 110px;
    height: 32px;
    background: linear-gradient(180deg, #fffda0 0%, #ffdb1e 100%);
    span {
      line-height: 32px;
      text-align: center;
      color: #b34000;
    }
  }
  .btn-dis {
    background: linear-gradient(180deg, #fecea6 0%, #fbaa65 100%);
  }
  .complete-class {
    width: 21px !important;
    height: 20px !important;
  }
}
.text-div {
  margin-top: 15px;
  span{
    line-height: 12px;
  }
}
.van-progress-jhd__pivot {
  background: transparent !important;
  // color: transparent !important;
  // top: 0 !important;
  // width: 27px !important;
  // height: 29px !important;
  // background: url(data:image/png;base64,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) no-repeat !important;
  // background-size: 27px 29px !important;
  // min-width:27px !important;
  padding: 0 !important;
}
.gift-class {
  // margin-left: -27px;
  width: 27px !important;
  height: 29px !important;
}
.sub-title {
  position: relative;
  // top: 0;
  height: 8px;
  background: #c74d0d;
  box-shadow: 0px 2px 11px 0px #e86528;
}
.tip-div {
  height: 258px;
  width: 259px;
  background: url("../../assets/signIn/tip.png") no-repeat;
  background-size: 100% 100%;
  font-size: 18px;
  font-weight: 500;
  .title1 {
    top: 112px;
    color: #ae3202;
    position: absolute;
    margin-left: 102px;
    height: 25px;
    line-height: 25px;
  }
  .title2 {
    font-size: 16px;
    top: 148px;
    color: #fff;
    position: absolute;
    margin-left: 104px;
    height: 22px;
    line-height: 22px;
    letter-spacing: 2px;
  }
}
.cal-out {
  .van-popup {
    background: transparent !important;
  }
  .van-popup--center {
    transform: translate3d(0%, -50%, 0);
    left: 48px;
  }
  .close-div {
    position: absolute;
    top: 60px;
    right: 50px;
  }
  .van-empty__description{
    font-size: 12px;
  }
}
</style>